import React from "react";

import { SHOP } from "../config";

const Footer = () => (
  <footer>
    <div className="topandbottom">
      <div className="topandbottom-text">
        Copyright &copy;
        <a
          href="https://www.linkedin.com/in/jan-vetrovsky/"
          target="_blank"
          rel="noreferrer"
        >
          Jan Větrovský
        </a>{" "}
        2021
      </div>
      <a href={SHOP.facebook} target="_blank" rel="noreferrer">
        <i className="fa fa-facebook" />
        Náš Facebook
      </a>
    </div>
  </footer>
);

export default Footer;
